module.exports = __webpack_public_path__ + "img/CapPunto.bed67fb4.png";